module.exports = ".eyes{position:absolute;top:50px;left:5%}.eyes .button{min-width:80px}\n"